var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"left"}),_c('div',{staticClass:"right"}),_c('div',{staticClass:"container"},[_c('div',{staticClass:"header"},[_c('p',[_vm._v(_vm._s(_vm.i18n.getLocalised('purchase.confirmAccount.end')))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }